// AJAX Participant Form Handler
// Handles form submission to custom server endpoint with modal feedback

(function() {
    'use strict';
    
    let isSubmitting = false;
    let form = null;
    
    // Phone number formatting function
    function formatPhoneNumber(value) {
        // Remove all non-digit characters
        const digits = value.replace(/\D/g, '');
        
        // Limit to 10 digits for US format (or 11 if starts with 1)
        let trimmedDigits = digits;
        
        // If starts with country code 1, allow 11 digits
        if (digits.startsWith('1')) {
            trimmedDigits = digits.substring(0, 11);
        } else {
            trimmedDigits = digits.substring(0, 10);
        }
        
        // Format based on length
        const len = trimmedDigits.length;
        
        if (len === 0) {
            return '';
        }
        
        // Handle numbers starting with country code 1
        if (trimmedDigits.startsWith('1') && len > 1) {
            if (len <= 2) {
                return '+1 (' + trimmedDigits.substring(1);
            } else if (len <= 5) {
                return '+1 (' + trimmedDigits.substring(1, 4) + (len > 4 ? ') ' + trimmedDigits.substring(4) : '');
            } else if (len <= 8) {
                return '+1 (' + trimmedDigits.substring(1, 4) + ') ' + trimmedDigits.substring(4, 7) + (len > 7 ? '-' + trimmedDigits.substring(7) : '');
            } else {
                return '+1 (' + trimmedDigits.substring(1, 4) + ') ' + trimmedDigits.substring(4, 7) + '-' + trimmedDigits.substring(7, 11);
            }
        }
        
        // Standard US format without country code
        if (len <= 3) {
            return '(' + trimmedDigits;
        } else if (len <= 6) {
            return '(' + trimmedDigits.substring(0, 3) + ') ' + trimmedDigits.substring(3);
        } else {
            return '(' + trimmedDigits.substring(0, 3) + ') ' + trimmedDigits.substring(3, 6) + '-' + trimmedDigits.substring(6, 10);
        }
    }
    
    // Set up phone input formatting
    function setupPhoneFormatting() {
        const phoneInputs = form.querySelectorAll('input[type="tel"]');
        
        phoneInputs.forEach(input => {
            // Format on input
            input.addEventListener('input', function(e) {
                const cursorPosition = this.selectionStart;
                const oldLength = this.value.length;
                const oldValue = this.value;
                
                // Format the value
                const formatted = formatPhoneNumber(this.value);
                this.value = formatted;
                
                // Adjust cursor position
                const newLength = formatted.length;
                const lengthDiff = newLength - oldLength;
                
                // Smart cursor positioning
                let newCursorPos = cursorPosition + lengthDiff;
                
                // If user just typed a digit and we added formatting, move cursor appropriately
                if (lengthDiff > 1 && cursorPosition === oldLength) {
                    newCursorPos = newLength;
                }
                
                // Ensure cursor doesn't go negative
                newCursorPos = Math.max(0, Math.min(newCursorPos, newLength));
                
                this.setSelectionRange(newCursorPos, newCursorPos);
            });
            
            // Handle paste
            input.addEventListener('paste', function(e) {
                e.preventDefault();
                const pastedText = (e.clipboardData || window.clipboardData).getData('text');
                const formatted = formatPhoneNumber(pastedText);
                this.value = formatted;
            });
            
            // Prevent non-numeric input (except formatting characters)
            input.addEventListener('keypress', function(e) {
                // Allow: backspace, delete, tab, escape, enter
                if ([8, 9, 27, 13, 46].indexOf(e.keyCode) !== -1 ||
                    // Allow: Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
                    (e.keyCode === 65 && e.ctrlKey === true) ||
                    (e.keyCode === 67 && e.ctrlKey === true) ||
                    (e.keyCode === 86 && e.ctrlKey === true) ||
                    (e.keyCode === 88 && e.ctrlKey === true)) {
                    return;
                }
                
                // Only allow digits
                if (!/[0-9]/.test(e.key)) {
                    e.preventDefault();
                }
            });
            
            // Set max length attribute as a fallback
            input.setAttribute('maxlength', '17'); // "+1 (XXX) XXX-XXXX" = 17 chars
            
            // Add placeholder hint
            if (!input.placeholder || input.placeholder === '+1 (555) 123-4567') {
                input.placeholder = '(555) 123-4567';
            }
        });
        
        console.log('Phone formatting set up for', phoneInputs.length, 'input(s)');
    }
    
    // Function to create and show loading modal
    function showLoadingModal() {
        // Remove any existing modal
        const existingModal = document.getElementById('loading-modal');
        if (existingModal) {
            existingModal.remove();
        }
        
        // Create loading modal HTML
        const modalHTML = `
            <div id="loading-modal" style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10000;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            ">
                <div style="
                    background: white;
                    padding: 40px;
                    border-radius: 12px;
                    text-align: center;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                    animation: modalSlideIn 0.3s ease-out;
                ">
                    <div style="
                        width: 40px;
                        height: 40px;
                        border: 4px solid #f3f3f3;
                        border-top: 4px solid #6B46C1;
                        border-radius: 50%;
                        animation: spin 1s linear infinite;
                        margin: 0 auto 20px;
                    "></div>
                    
                    <h3 style="
                        color: #374151;
                        font-size: 20px;
                        font-weight: 600;
                        margin-bottom: 10px;
                    ">Processing Your Application</h3>
                    
                    <p style="
                        color: #6B7280;
                        font-size: 16px;
                        margin: 0;
                    ">Please wait while we submit your information...</p>
                </div>
            </div>
            <style>
                @keyframes modalSlideIn {
                    from {
                        opacity: 0;
                        transform: translateY(-20px);
                    }
                    to {
                        opacity: 1;
                        transform: translateY(0);
                    }
                }
                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }
            </style>
        `;
        
        // Insert modal into DOM
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        console.log('Loading modal displayed');
    }
    
    // Function to create and show success modal
    function showSuccessModal(message, participantData) {
        // Remove loading modal first
        const loadingModal = document.getElementById('loading-modal');
        if (loadingModal) {
            loadingModal.remove();
        }
        
        // Remove any existing success modal
        const existingModal = document.getElementById('success-modal');
        if (existingModal) {
            existingModal.remove();
        }
        
        // Create success modal HTML
        const modalHTML = `
            <div id="success-modal" style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10000;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            ">
                <div style="
                    background: white;
                    padding: 40px;
                    border-radius: 12px;
                    max-width: 493px;
                    width: 90%;
                    text-align: center;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                    position: relative;
                    animation: modalSlideIn 0.3s ease-out;
                ">
                    <button id="close-success-modal" style="
                        position: absolute;
                        top: 15px;
                        right: 15px;
                        background: none;
                        border: none;
                        font-size: 24px;
                        cursor: pointer;
                        color: #666;
                        padding: 5px;
                        line-height: 1;
                    ">&times;</button>
                    
                    <h2 style="
                        font-family: var(--font-body);
                        color: #63308A;
                        font-size: 24px;
                        font-weight: 600;
                        margin-bottom: 20px;
                        line-height: 1.3;
                    ">Thank you for your interest in becoming a participant!</h2>
                    
                    <p style="
                        color: #303132;
                        font-size: 16px;
                        line-height: 1.5;
                        margin-bottom: 20px;
                    ">We’re reviewing the information you provided and will reach out about next steps soon.</p>
                    
                    <p style="
                        color: #303132;
                        font-size: 16px;
                        line-height: 1.5;
                        margin-bottom: 0;
                    ">If you have any questions in the meantime, check out our <a href="/pages/help-center" style="color:#303132;" target="_blank">help center</a> or email us at <a href="mailto:hello@lovealways.com" style="color:#303132;">hello@lovealways.com</a>.</p>
                </div>
            </div>
        `;
        
        // Insert modal into DOM
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        
        // Add event listeners
        const modal = document.getElementById('success-modal');
        const closeBtn = document.getElementById('close-success-modal');
        
        // Close modal when clicking X button
        closeBtn.addEventListener('click', function() {
            modal.remove();
        });
        
        // Close modal when clicking outside
        modal.addEventListener('click', function(e) {
            if (e.target === modal) {
                modal.remove();
            }
        });
        
        // Close modal with Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && document.getElementById('success-modal')) {
                modal.remove();
            }
        });
        
        console.log('Success modal displayed');
    }
    
    // Function to create and show error modal
    function showErrorModal(errorMessage, errors = []) {
        // Remove any existing modals
        const existingModal = document.getElementById('error-modal');
        if (existingModal) {
            existingModal.remove();
        }
        
        const loadingModal = document.getElementById('loading-modal');
        if (loadingModal) {
            loadingModal.remove();
        }
        
        // Generate error list HTML if specific errors provided
        let errorListHTML = '';
        if (errors.length > 0) {
            errorListHTML = '<ul style="text-align: left; margin: 20px 0; padding-left: 20px; color: #dc2626;">';
            errors.forEach(error => {
                errorListHTML += `<li style="margin-bottom: 8px;"><strong>${error.field}:</strong> ${error.message}</li>`;
            });
            errorListHTML += '</ul>';
        }
        
        // Create error modal HTML
        const modalHTML = `
            <div id="error-modal" style="
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                display: flex;
                justify-content: center;
                align-items: center;
                z-index: 10000;
                font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
            ">
                <div style="
                    background: white;
                    padding: 40px;
                    border-radius: 12px;
                    max-width: 450px;
                    width: 90%;
                    text-align: center;
                    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
                    position: relative;
                    animation: modalSlideIn 0.3s ease-out;
                    border-top: 4px solid #dc2626;
                ">
                    <button id="close-error-modal" style="
                        position: absolute;
                        top: 15px;
                        right: 15px;
                        background: none;
                        border: none;
                        font-size: 24px;
                        cursor: pointer;
                        color: #666;
                        padding: 5px;
                        line-height: 1;
                    ">&times;</button>
                    
                    <div style="
                        width: 60px;
                        height: 60px;
                        border-radius: 50%;
                        background-color: #fee2e2;
                        margin: 0 auto 20px;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                    ">
                        <span style="
                            color: #dc2626;
                            font-size: 30px;
                            font-weight: bold;
                        ">!</span>
                    </div>
                    
                    <h2 style="
                        color: #dc2626;
                        font-size: 22px;
                        font-weight: 600;
                        margin-bottom: 15px;
                    ">Submission Error</h2>
                    
                    <p style="
                        color: #374151;
                        font-size: 16px;
                        line-height: 1.5;
                        margin-bottom: 10px;
                    ">${errorMessage}</p>
                    
                    ${errorListHTML}
                    
                    <button id="try-again-btn" style="
                        background-color: #dc2626;
                        color: white;
                        border: none;
                        padding: 12px 24px;
                        border-radius: 6px;
                        font-size: 16px;
                        font-weight: 500;
                        cursor: pointer;
                        margin-top: 10px;
                        transition: background-color 0.2s;
                    " onmouseover="this.style.backgroundColor='#b91c1c'" onmouseout="this.style.backgroundColor='#dc2626'">
                        Try Again
                    </button>
                </div>
            </div>
        `;
        
        // Insert modal into DOM
        document.body.insertAdjacentHTML('beforeend', modalHTML);
        
        // Add event listeners
        const modal = document.getElementById('error-modal');
        const closeBtn = document.getElementById('close-error-modal');
        const tryAgainBtn = document.getElementById('try-again-btn');
        
        // Close modal when clicking X button or Try Again
        [closeBtn, tryAgainBtn].forEach(btn => {
            btn.addEventListener('click', function() {
                modal.remove();
            });
        });
        
        // Close modal when clicking outside
        modal.addEventListener('click', function(e) {
            if (e.target === modal) {
                modal.remove();
            }
        });
        
        // Close modal with Escape key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' && document.getElementById('error-modal')) {
                modal.remove();
            }
        });
        
        console.log('Error modal displayed');
    }
    
    // Function to validate form fields
    function validateForm(formData) {
        const errors = [];
        
        // Define required fields with more specific validation
        const requiredFields = [
            { 
                name: 'category', 
                displayName: 'Category',
                type: 'select'
            },
            { 
                name: 'name', 
                displayName: 'Name',
                type: 'text',
                minLength: 2,
                maxLength: 100
            },
            { 
                name: 'company_name', 
                displayName: 'Company Name',
                type: 'text',
                minLength: 2,
                maxLength: 100
            },
            { 
                name: 'email', 
                displayName: 'Email',
                type: 'email'
            },
            { 
                name: 'phone', 
                displayName: 'Phone',
                type: 'tel',
                minLength: 10,
                maxLength: 20
            }
        ];
        
        console.log('Validating form fields...');
        
        // Check required fields
        requiredFields.forEach(field => {
            let value = '';
            
            if (field.type === 'radio') {
                // Special handling for radio buttons
                const checkedRadio = form.querySelector(`input[name="${field.name}"]:checked`);
                value = checkedRadio ? checkedRadio.value.trim() : '';
            } else if (field.type === 'select') {
                // Special handling for select dropdown
                const select = form.querySelector(`select[name="${field.name}"]`);
                value = select ? select.value.trim() : '';
            } else {
                // Regular input fields
                value = formData.get(field.name) ? formData.get(field.name).toString().trim() : '';
            }
            
            console.log(`Checking ${field.displayName}: "${value}"`);
            
            // Required field check
            if (!value) {
                errors.push({
                    field: field.displayName,
                    message: 'This field is required'
                });
                addFieldError(field.name);
                return; // Skip other validations if field is empty
            }
            
            // Length validations (for non-phone fields, use original value)
            // For phone, extract digits only for length check
            if (field.type === 'tel') {
                const digitsOnly = value.replace(/\D/g, '');
                
                if (digitsOnly.length < 10) {
                    errors.push({
                        field: field.displayName,
                        message: 'Phone number must be at least 10 digits'
                    });
                    addFieldError(field.name);
                } else if (digitsOnly.length > 11) {
                    errors.push({
                        field: field.displayName,
                        message: 'Phone number is too long'
                    });
                    addFieldError(field.name);
                }
            } else {
                if (field.minLength && value.length < field.minLength) {
                    errors.push({
                        field: field.displayName,
                        message: `Must be at least ${field.minLength} characters`
                    });
                    addFieldError(field.name);
                }
                
                if (field.maxLength && value.length > field.maxLength) {
                    errors.push({
                        field: field.displayName,
                        message: `Must be no more than ${field.maxLength} characters`
                    });
                    addFieldError(field.name);
                }
            }
            
            // Email-specific validation
            if (field.type === 'email' && value) {
                const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
                
                if (!emailRegex.test(value)) {
                    errors.push({
                        field: field.displayName,
                        message: 'Please enter a valid email address'
                    });
                    addFieldError(field.name);
                } else if (value.length < 5 || value.length > 254) {
                    errors.push({
                        field: field.displayName,
                        message: 'Email must be between 5 and 254 characters'
                    });
                    addFieldError(field.name);
                } else if (value.includes('..') || value.startsWith('.') || value.endsWith('.')) {
                    errors.push({
                        field: field.displayName,
                        message: 'Invalid email format'
                    });
                    addFieldError(field.name);
                }
            }
            
            // Name-specific validation (no numbers, reasonable characters)
            if (field.name === 'name' && value) {
                const nameRegex = /^[a-zA-Z\s\-\.\']+$/;
                if (!nameRegex.test(value)) {
                    errors.push({
                        field: field.displayName,
                        message: 'Name can only contain letters, spaces, hyphens, periods, and apostrophes'
                    });
                    addFieldError(field.name);
                }
            }
        });
        
        // Check terms agreement checkbox if present
        const termsCheckbox = form.querySelector('input[name="terms_agreement"]');
        if (termsCheckbox) {  // Removed the hasAttribute('required') check
            if (!termsCheckbox.checked) {
                errors.push({
                    field: 'Terms Agreement',
                    message: 'Please confirm that you have read and agreed to our Terms of Service and Privacy Policy'
                });
                addFieldError('terms_agreement');
            }
        }
        
        console.log(`Validation complete. Found ${errors.length} errors.`);
        return errors;
    }
    
    // Function to add visual error styling to form field
    function addFieldError(fieldName) {
        const field = form.querySelector(`[name="${fieldName}"]`);
        if (!field) return;
        
        // Add error styling
        field.style.border = '2px solid #dc2626';
        field.style.boxShadow = '0 0 0 3px rgba(220, 38, 38, 0.1)';
        
        // Add error class for animation
        field.classList.add('form-field-error');
        
        // Add CSS for shake animation if not already present
        if (!document.querySelector('#form-error-styles')) {
            const styles = document.createElement('style');
            styles.id = 'form-error-styles';
            styles.textContent = `
                .form-field-error {
                    animation: fieldShake 0.5s ease-in-out;
                }
                
                @keyframes fieldShake {
                    0%, 100% { transform: translateX(0); }
                    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
                    20%, 40%, 60%, 80% { transform: translateX(5px); }
                }
            `;
            document.head.appendChild(styles);
        }
        
        // Remove animation class after it completes
        setTimeout(() => {
            field.classList.remove('form-field-error');
        }, 500);
    }
    
    // Function to remove error styling from form field
    function removeFieldError(fieldName) {
        const field = form.querySelector(`[name="${fieldName}"]`);
        if (!field) return;
        
        // Remove error styling
        field.style.border = '';
        field.style.boxShadow = '';
        field.classList.remove('form-field-error');
    }
    
    // Function to clear all form fields after successful submission
    function clearForm() {
        if (!form) return;
        
        console.log('Clearing form fields...');
        
        // Clear text inputs
        const textInputs = form.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input[type="url"]');
        textInputs.forEach(input => {
            input.value = '';
            removeFieldError(input.name);
        });
        
        // Clear select dropdown
        const selects = form.querySelectorAll('select');
        selects.forEach(select => {
            select.selectedIndex = 0;
            removeFieldError(select.name);
        });
        
        // Clear radio buttons
        const radios = form.querySelectorAll('input[type="radio"]');
        radios.forEach(radio => {
            radio.checked = false;
        });
        
        // Clear checkboxes
        const checkboxes = form.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            checkbox.checked = false;
        });
        
        console.log('Form cleared successfully');
    }
    
    // Function to handle form submission
    async function handleFormSubmit(e) {
        e.preventDefault();
        
        // Prevent double submission
        if (isSubmitting) {
            console.log('Form submission already in progress');
            return;
        }
        
        console.log('Starting form submission...');
        isSubmitting = true;
        
        // Get form data
        const formData = new FormData(form);
        formData.set('joining_type', 'company');
        
        // Client-side validation
        const validationErrors = validateForm(formData);
        if (validationErrors.length > 0) {
            console.log('Client-side validation failed:', validationErrors);
            showErrorModal('Please correct the following errors:', validationErrors);
            isSubmitting = false;
            return;
        }
        
        // Clear any existing field errors since validation passed
        const allFields = ['joining_type', 'category', 'name', 'company_name', 'company_website', 'email', 'phone'];
        allFields.forEach(fieldName => {
            removeFieldError(fieldName);
        });
        
        // Show loading modal
        showLoadingModal();
        
        // Get submit button and show loading state
        const submitButton = form.querySelector('button[type="submit"]');
        const originalButtonText = submitButton ? submitButton.textContent : '';
        if (submitButton) {
            submitButton.disabled = true;
            submitButton.textContent = 'Submitting...';
        }
        
        try {
            // Get endpoint from form action attribute (configurable)
            const endpointPath = form.dataset.endpointPath || '/clients/join';
            const endpoint = window.ENV_CONFIG?.getProxyUrl(endpointPath) || endpointPath;

            console.log('Environment:', window.ENV_CONFIG?.environment);
            console.log('Endpoint Path:', endpointPath);
            console.log('Full Endpoint:', endpoint);
            
            // Submit to your server
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams(formData)
            });
            
            console.log('Submitting to:', endpoint);
            console.log('Server response status:', response.status);
            
            if (!response.ok) {
                throw new Error(`HTTP ${response.status}: Server error`);
            }
            
            // Try to parse JSON response
            const result = await response.json();
            console.log('Server response:', result);
            
            if (result.success) {
                // Success - clear form and show success modal
                console.log('Form submission successful');
                clearForm();
                showSuccessModal(result.message, result.data);
            } else {
                // Server returned error
                console.error('Server returned error:', result.error);
                showErrorModal(result.error || 'An error occurred while submitting the form');
            }
            
        } catch (error) {
            console.error('Form submission error:', error);
            
            // Handle different types of errors with specific messages
            let errorMessage = 'There was an error submitting your application. Please try again.';
            
            if (error.message.includes('Failed to fetch') || error.name === 'TypeError') {
                errorMessage = 'Unable to connect to the server. Please check your internet connection and try again.';
            } else if (error.message.includes('HTTP 400')) {
                errorMessage = 'There was a validation error with your form data. Please check your information and try again.';
            } else if (error.message.includes('HTTP 401')) {
                errorMessage = 'Authentication error. Please refresh the page and try again.';
            } else if (error.message.includes('HTTP 403')) {
                errorMessage = 'Access denied. Please contact support if this error persists.';
            } else if (error.message.includes('HTTP 404')) {
                errorMessage = 'Form submission endpoint not found. Please contact support.';
            } else if (error.message.includes('HTTP 429')) {
                errorMessage = 'Too many requests. Please wait a moment and try again.';
            } else if (error.message.includes('HTTP 500') || error.message.includes('HTTP 502') || error.message.includes('HTTP 503')) {
                errorMessage = 'Server error. Please try again in a few moments.';
            } else if (error.message.includes('timeout')) {
                errorMessage = 'Request timed out. Please check your connection and try again.';
            }
            
            showErrorModal(errorMessage);
        } finally {
            // Reset submission state and button
            isSubmitting = false;
            if (submitButton) {
                submitButton.disabled = false;
                submitButton.textContent = originalButtonText;
            }
        }
    }
    
    // Function to set up input field validation listeners
    function setupFieldValidation() {
        const allFields = ['joining_type', 'category', 'name', 'company_name', 'company_website', 'email', 'phone'];
        
        allFields.forEach(fieldName => {
            const field = form.querySelector(`[name="${fieldName}"]`);
            if (field) {
                // Clear error styling when user interacts with field
                const clearError = () => removeFieldError(fieldName);
                
                field.addEventListener('input', clearError);
                field.addEventListener('change', clearError);
                field.addEventListener('focus', clearError);
            }
        });
        
        console.log('Field validation listeners set up');
    }
    
    // Main initialization function
    function initializeForm() {
        // Find the form
        form = document.querySelector('.custom-form__form');
        
        if (!form) {
            console.log('Custom form not found, retrying...');
            setTimeout(initializeForm, 100);
            return;
        }
        
        console.log('Participant form found, initializing AJAX handler...');
        
        // Set up form submission handler
        form.addEventListener('submit', handleFormSubmit);
        
        // Set up field validation
        setupFieldValidation();
        
        // Set up phone formatting
        setupPhoneFormatting();
        
        console.log('AJAX form handler initialized successfully');
    }
    
    // Start when DOM is ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeForm);
    } else {
        initializeForm();
    }
    
})();

// Global debugging function
window.debugParticipantForm = function() {
    console.log('=== PARTICIPANT FORM DEBUG ===');
    
    const form = document.querySelector('.custom-form__form');
    if (!form) {
        console.log('Form not found');
        return;
    }
    
    console.log('Form found:', form);
    console.log('Form action:', form.action);
    console.log('Form method:', form.method);
    
    const formData = new FormData(form);
    console.log('Current form data:');
    for (let [key, value] of formData.entries()) {
        console.log(`- ${key}: "${value}"`);
    }
};